import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Events, EventType } from 'app/events';

import { ActionButton, MaskedImage } from 'app/components/common';

import './styles.less';

export const CourseListItem = ( props ) => {
    const [ isProcessingAction, setProcessingAction ] = useState( false );
    const { course, token } = props;

    // TODO: Get launch button text from translation service.
    const launchButtonText = 'Launch Now';

    // A callback used to handle the actual launching of the course.
    const handleLaunchCourse = useCallback( async () => {
        setProcessingAction( true );
        await Events.invoke( EventType.LAUNCH_COURSE, { courseId: course?.id, token: token, debug: true } );
        setProcessingAction( false );
    }, [ course, setProcessingAction, token ] );

    // Construct the classes to use for the component root.
    const classes = classnames (
        'course-list-item',
        { [ props.className ]: Boolean( props?.className ) },
    );

    return (
        <div className={ classes }>
            <span className="course-list-item-content">
                <MaskedImage
                    src={ !props.loading ? course.thumbnailImage : '' }
                    maskSrc="/images/course-image-mask.png"
                    className="course-image"
                    width="125"
                    height="65"
                    overlayColor={ !props.loading ? '#0090cf' : '#000000' }
                    overlayOpacity={ !props.loading ? 0.6 : 0.3 }
                />
                <div className="course-details">
                    <span className="course-title">
                        { !props.loading
                            ? course.name
                            : ''
                        }
                    </span>
                </div>
                <ActionButton
                    className="launch-button"
                    loading={ isProcessingAction }
                    disabled={ props.disabled || props.loading }
                    onClick={ handleLaunchCourse }
                    blue
                >
                    { launchButtonText }
                </ActionButton>
            </span>
        </div>
    );
};

CourseListItem.propTypes = {
    disabled: false,
    loading: false,
};

CourseListItem.propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    course: PropTypes.object,
    loading: PropTypes.bool,
};
